import { render, staticRenderFns } from "./SimilarEntityTable.vue?vue&type=template&id=0cd87d5e&"
import script from "./SimilarEntityTable.vue?vue&type=script&lang=js&"
export * from "./SimilarEntityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports